import { render, staticRenderFns } from "./AssignAgentsEmployees.vue?vue&type=template&id=77235114&scoped=true&"
import script from "./AssignAgentsEmployees.vue?vue&type=script&lang=ts&"
export * from "./AssignAgentsEmployees.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77235114",
  null
  
)

export default component.exports